<template>
    <detail-header
        pretitle="aqfer Universal Tag"
        :title="$route.params.hostName"
        :editable="false"
        :editMode="editMode"
        :customMode="true"
        customModeText="Add Domain Record"
        :customModeRoles="btnRoles"
        @customClick="onAddDomainEntree"
        @closeClick="$router.push({name: 'Configure Hosts'})"
    />

    <div class="container-fluid">         
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <datatable
                        tableId="configureList"
                        :columns="columns"
                        uniqueField="name"
                        :data="cNameList"
                        :compact="true"
                        :deletable="canEdit"
                        :showLoading="loading"
                        @deleteRows="DeleteDomainEntries"
                        :selectCheckboxes="canEdit"
                        customTitle="Refresh <i class='fa fa-refresh'></i>" 
                        customClass="btn btn-sm btn-outline-secondary"
                        customTooltip="Refresh the status of all domains under this edge hostname."
                        @customActionButton="onRefresh"
                        customTitle2="Validate"
                        customClass2="btn btn-sm btn-outline-primary"
                        customTooltip2="Validate all domains and list the expected DNS mappings that are missing."
                        @customActionButton2="onValidate"
                        @viewModal="openModal" 
                        :viewModalColumn="viewModalColumn"
                        :viewModalText="true"
                        viewModalValidationText="NOT_VALIDATED"
                    />
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
import DetailHeader from '../../components/DetailHeader.vue';
import Datatable from "../../components/Datatable.vue";
import { mapActions, mapState } from "vuex";
export default {
    components: { Datatable, DetailHeader },
    data() {
        return {
            columns: [
                { data: "name", title: "CName" },
                { data: "status" },
                { data:"recordType", title:"Type" }
            ],
            edgeHostName: this.$route.params.hostName,
            editMode: false,
            btnRoles: [1, 1.5, 3],
            loading: true,
        };
    },
    computed: {
     ...mapState({ 
            cid: state => state.currentClient.cid,
            edgeHostObj: state => state.aut.currentEdgeHostNameObj
        }), 
        cNameList() {
            const currentEdgeHostName = this.$store.state.aut.currentEdgeHostNameObj;
            return currentEdgeHostName.domains?currentEdgeHostName.domains.items:null;
        },
        canEdit() {
            return this.$store.getters.userRoles.isClientAdmin || this.$store.getters.userRoles.isAqferAdmin || this.$store.getters.userRoles.isAqferManager;
        },
        viewModalColumn() {
            // When `selectCheckboxes` is true, datatable inserts a column at index 0,
            // so the "status" column becomes index 2 (vs 1 without checkboxes).
            return this.canEdit ? 2 : 1;
        },
    }, 
   
    methods: {
        ...mapActions({
            showModal: "showModal",
            getDomainListObject: "aut/getDomainListObject",
            updateEdgeHostname:"aut/updateEdgeHostname"
        }),
        onAddDomainEntree() {
            this.showModal({ component: 'addEdgeHost', data: JSON.parse(JSON.stringify(this.edgeHostObj) )});
        },
        DeleteDomainEntries(rows) {
            const deleteRowNameArr = rows.map(row => {
                return row.name;
            });
            const filteredDomains = this.edgeHostObj.domains.items.filter(item => {
                return !deleteRowNameArr.includes(item.name);
            });

            const edgeHostObjCopy = JSON.parse(JSON.stringify(this.edgeHostObj));

            edgeHostObjCopy.domains.items = filteredDomains;
            this.showModal({ component: "deleteDomainRecords", data: {edgeHostObj: edgeHostObjCopy, rows: rows }});
        },
        openModal(row) {
            const validationDetails = row?.validationDetails || row?.validation_details || null;
            const recordType = row?.recordType || 'CNAME';
            const edgeHostname = this.edgeHostObj?.edgeHostname || 'e1.a00000-cXXX.edgekey.net';
            const domainName = (row?.name || '').trim();
            const parts = domainName ? domainName.split('.') : [];
            const subdomain = parts[0] || '';
            const domain = parts.length > 1 ? parts.slice(1).join('.') : '';
            const hasSubdomainAndDomain = subdomain && domain;
            const aliasRecordLeft = hasSubdomainAndDomain ? domainName : null;
            const aliasRecordRight = hasSubdomainAndDomain ? `${subdomain}1.${domain}` : null;
            const { showAliasRecord, showCnameRecord } = this.getDnsVisibilityByRecordType(recordType);
            const cnameRecordLeft = domainName || null;
            const cnameRecordRight = domainName
                ? (recordType === 'FWD' ? 'xxxxxxxxxxxxx.cloudfront.net' : edgeHostname)
                : null;
            this.showModal({
                component: "CNameValidation",
                data: {
                    domain: row?.name,
                    status: row?.status,
                    recordType,
                    validationDetails,
                    edgeHostname,
                    aliasRecordLeft,
                    aliasRecordRight,
                    cnameRecordLeft,
                    cnameRecordRight,
                    showAliasRecord: showAliasRecord && Boolean(aliasRecordLeft && aliasRecordRight),
                    showCnameRecord: showCnameRecord && Boolean(cnameRecordLeft && cnameRecordRight),
                    onRefresh: () => this.onRefresh(),
                },
            });
        },
        getDnsVisibilityByRecordType(recordType) {
            if (recordType === 'PROXY') {
                return { showAliasRecord: true, showCnameRecord: true };
            }
            return { showAliasRecord: false, showCnameRecord: true };
        },
        onRefresh() {
            let expiredCNames = [];
            for (const item of this.cNameList) {
                let expiryTime = item.validationDetails?.validation_expiry || null;
                if (expiryTime) {
                    expiryTime = new Date(expiryTime);
                    const now = new Date();
                    if (expiryTime < now) {
                        expiredCNames.push(item);
                    }
                }
            }
            this.showModal({
                component: "DomainRefreshMethod",
                data: {
                    onSelect: (method) => this.refreshDomains(method),
                    expiredCNames: expiredCNames,
                },
            });
        },
        onValidate() {
            this.showModal({
                component: "DomainRefreshMethod",
                data: {
                    title: "Choose the validation method",
                    description: "Select the ownership validation method to be used.",
                    cnameLabel: "DNS CNAME",
                    txtLabel: "DNS TXT",
                    onSelect: (method) => this.validateDomains(method),
                },
            });
        },
        async refreshDomains(method) {
            let toastOptions;
            let domainListObj = {};
            const domainArr = [];

            if (this.edgeHostObj) {
                domainListObj = JSON.parse(JSON.stringify(this.edgeHostObj));
                domainListObj.domains = this.edgeHostObj.domains;
                domainListObj.domains.items = [...this.edgeHostObj.domains.items, ...domainArr];
                domainListObj.ipType = this.edgeHostObj.ipType;
            }

            try {
                const res = await this.updateEdgeHostname({
                    payload: domainListObj,
                    validationMethod: method === "DNS_TXT" ? "DNS_TXT" : null,
                });
                toastOptions = {
                    message: "Domains statuses have been refreshed successfully.",
                    type: "success",
                };
            } catch (error) {
                if (error?.response?.data?.error) this.error = error.response.data.error;
                else this.error = error.message;

                toastOptions = {
                    message: this.error || "Something went wrong when refreshing domains. Please contact support.",
                    type: "error",
                };
                this.$store.dispatch("addToast", toastOptions);
                return;
            }
            this.$store.dispatch('hideModal');
            this.$store.dispatch("addToast", toastOptions);
            if (toastOptions.type === "success") {
                await this.$store.dispatch("aut/getDomainListObject", this.edgeHostName);
            }
        },
        /**
         * Parse validation API error string into per-domain messages.
         * Format: "invalid input: domain1: msg1;msg2\ndomain2: msg3" or plain text.
         */
        parseValidationError(errorString) {
            const raw = typeof errorString === 'string' ? errorString : String(errorString || '');
            let text = raw.trim();
            if (text.toLowerCase().startsWith('invalid input:')) {
                text = text.slice('invalid input:'.length).trim();
            }
            const parsedErrors = [];
            const lines = text.split(/\n/).map((l) => l.trim()).filter(Boolean);
            for (const line of lines) {
                const colonIdx = line.indexOf(': ');
                let domain = '';
                let msgPart = line;
                if (colonIdx > 0) {
                    domain = line.slice(0, colonIdx).trim();
                    msgPart = line.slice(colonIdx + 2).trim();
                }
                const messages = msgPart.split(';').map((m) => m.trim()).filter(Boolean);
                if (messages.length) parsedErrors.push({ domain, messages });
                else if (line) parsedErrors.push({ domain: '', messages: [line] });
            }
            return { parsedErrors, rawMessage: raw };
        },
        async validateDomains(validationMethod = null) {
            let toastOptions;
            let domainListObj = {};
            const domainArr = [];

            if (this.edgeHostObj) {
                domainListObj = JSON.parse(JSON.stringify(this.edgeHostObj));
                domainListObj.domains = this.edgeHostObj.domains;
                domainListObj.domains.items = [...this.edgeHostObj.domains.items, ...domainArr];
                domainListObj.ipType = this.edgeHostObj.ipType;
            }

            try {
                await this.updateEdgeHostname({
                    payload: domainListObj,
                    validate: true,
                    validationMethod: validationMethod === "DNS_TXT" ? "DNS_TXT" : null,
                });
                toastOptions = {
                    message: "Validation triggered successfully!",
                    type: "success",
                };
                this.$store.dispatch("addToast", toastOptions);
                await this.$store.dispatch("aut/getDomainListObject", this.edgeHostName);
            } catch (error) {
                const errMsg = error?.response?.data?.error ?? error?.message ?? '';
                this.error = errMsg;
                const parsed = this.parseValidationError(errMsg);
                this.showModal({
                    component: "ValidationErrorModal",
                    data: {
                        rawMessage: parsed.rawMessage,
                        parsedErrors: parsed.parsedErrors,
                    },
                });
            }
        },
        
    },
    async beforeMount() {
        this.loading = true;     
        await this.$store.dispatch("aut/getDomainListObject", this.edgeHostName);    
        this.loading = false;    
    }   
}
</script>

<style>

</style>